import { z } from "zod";
import { MessageKind } from "./kinds.js";
/**
 * The search query AST (architecture §6.5). `@kwp/domain` parses Gmail-syntax text into it and
 * compiles it per backend; providers receive it as is (`MailProvider.search`), and stored rules
 * keep it as their match. Scope operators (`account:`, `workspace:`) never appear here: the
 * parser lifts them out and the api narrows the accounts searched with them.
 */
export const QueryLocation = z.enum(["inbox", "archive", "spam", "trash", "sent", "drafts", "anywhere"]);
export const QueryFlag = z.enum(["unread", "read", "starred", "unstarred"]);
export const QueryTextField = z.enum(["from", "to", "cc", "subject", "filename"]);
/**
 * What a `source` node tests (§6.7, WP-062): `from-app:` the app, `gh:` the thread's GitHub group,
 * `gh-reason:` one reason, `repo:` the repository, `is:pr`/`is:issue` the item.
 */
export const QuerySourceField = z.enum(["app", "group", "reason", "repo", "item"]);
export const QueryNode = z.lazy(() => z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("and"), terms: z.array(QueryNode) }),
    z.object({ kind: z.literal("or"), terms: z.array(QueryNode) }),
    z.object({ kind: z.literal("not"), term: QueryNode }),
    z.object({ kind: z.literal("field"), field: QueryTextField, value: z.string().min(1) }),
    z.object({ kind: z.literal("text"), value: z.string().min(1), phrase: z.boolean() }),
    z.object({ kind: z.literal("tag"), value: z.string().min(1) }),
    z.object({ kind: z.literal("in"), location: QueryLocation }),
    z.object({ kind: z.literal("is"), flag: QueryFlag }),
    z.object({ kind: z.literal("hasAttachment") }),
    z.object({ kind: z.literal("date"), op: z.enum(["before", "after"]), date: z.date() }),
    z.object({ kind: z.literal("messageKind"), value: MessageKind }),
    z.object({ kind: z.literal("source"), field: QuerySourceField, value: z.string().min(1) }),
]));
/** The query that matches everything (an empty `and`). */
export const MATCH_ALL = { kind: "and", terms: [] };
//# sourceMappingURL=query.js.map